/* eslint-disable no-template-curly-in-string */
export const properties = {
  ruteServerImagenesFondos: '/imagenes/fondos/',
  ruteServerImagenesLeyendas: '/imagenes/leyendas/',
  ruteServerImagenesEsquemas: '/imagenes/esquemas/',
  ruteServerImagenesEscalas: '/imagenes/escalas/',
  ruteServerImagenesComunes: '/imagenes/comunes/',
  ruteServerImagenesPortada: '/imagenes/portada/300/',
  ruteServerECWS: "file://cache_iberpix_3",
  //ruteServerECWS: "file://Wp34cnig001.cnig.local/cache_iberpix_3",
  ruteServerPNOA: "file://publicacion-pnoa-ma",
  //ruteServerPNOA: "file://Wp34cnig001.cnig.local/publicacion-pnoa-ma",
  ruteServerECWSUbicacion: "/Wp34cnig001.cnig.local/cache_iberpix_3/",
  //title: 'Mapa a la Carta',
  apiURLMaths: 'https://www.ign.es/web/ign/portal/gmt-declinacion-magnetica/-/declinacion-magnetica/infoVisor?', //for Maths.js
  apiURLApiService:'https://mapaalacarta.cnig.es', //for apiService.js
  urlGeocoder: 'https://www.cartociudad.es/geocoder',
  //apiURLApiService: 'http://localhost:8080',
  MAX_POST_SIZE: 1048576, // 1MB exacto es 1048576 bytes
  DEFAULT_WIDTH: 831,
  DEFAULT_HEIGHT: 1228,
  //Número de kilómetros que existen desde el centro del mapa al lado más largo en una escala 1:5000
  PROPORTION_PIXEL_DISTANCE_LONGSIDE: 544 / 375,
  PROPORTION_PIXEL_DISTANCE_LONGSIDE_VERTICAL: 1.450283,
  PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_HORIZONTAL: 1.72332846715,
  PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_VERTICAL: 1.6897972425,
  PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_HORIZONTAL_LEYENDA: 1.5255,
  PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_VERTICAL_LEYENDA: 1.48901,
  //Número de kilómetros que existen desde el centro del mapa al lado más corto en una escala 1:5000
  PROPORTION_PIXEL_DISTANCE_SHORTSIDE: 369 / 400,
  PROPORTION_PIXEL_DISTANCE_SHORTSIDE_VERTICAL: 0.923708,
  PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_HORIZONTAL: 1.06510019084,
  PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_VERTICAL: 1.16280772901,
  PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_HORIZONTAL_LEYENDA: 1.0682,
  PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_VERTICAL_LEYENDA: 1.1675,
  FORMATOS_PERMITIDOS_IMAGEN: 'PNG y JPG',
  RATIO_CUSTOM_IMAGE: '2:3',
  RATIO_CUSTOM_IMAGE_VERTICAL: '36:17',
  //Hay que tener en cuenta que despues de las rutas de 25k y la de 50k viene el huso y es variable
  ECW25k_FOLDER_ROUTE: '/01_Mapa_mapaBTN25/MAPA_CARTA/ESPANA_dic_2025/HUSO', // En desarrollo Guadaltel es ESPANA_2023
  ECW50k_FOLDER_ROUTE: '/01_Mapa_mapaBTN50/MAPA_CARTA/ESPANA_dic_2025/ECW/HUSO', // En desarrollo Guadaltel es ESPANA_2023
  //Nombre de los ficheros ecw antes de la proyección y numero de hoja. Ejemplo: mtn25_epsg32628_1093-2.ecw
  //solo tendríamos que poner mtn25_epsg
  ECW50k_FILE_NAME: 'mapaBTN50_epsg',
  ECW25k_FILE_NAME: 'mapaBTN25_epsg',
  PNOA_FILE_NAME: 'PNOA_MA_H${huso}/PNOA_MA_OF_${src}_HU${huso}_h25_${hoja}.tif',
  PNOA_OV_FOLDER_NAME: 'PNOA_OV_H${huso}',
  TIPOS_DE_PAPEL_COMPRA: ['Normalsinplegar', 'Normalplegado', 'Aventurasinplegar', 'Aventuraplegado', 'Satinadosinplegar', 'Rigidosinplegar', 'Fotograficosinplegar', 'PosterNormalsinplegar', 'FotoNormalsinplegar', 'FotoRigidosinplegar', 'FotoAventurasinplegar','PosterAventurasinplegar'],
  WAITING_TIME_PDF_PNOA: 32000,
  WAITING_TIME_PDF_MTN: 180000,
  //PNOA_MODE: 'REMOTE',
  PNOA_MODE: 'LOCAL',
  SERVICE_NAMES: ['AU.AdministrativeUnit', 'IGNBaseOrto'],
  LIMIT_SHEET_PNOA_NORTH: 623,
  SERVICE_URLS: ['https://www.ign.es/wms-inspire/unidades-administrativas', 'https://www.ign.es/wms-inspire/ign-base'],
  SERVICE_DISPLAY_NAMES: ['Unidades administrativas', 'Callejero'],
  ROUTE_CATALOGUE_URLS: 'https://centrodedescargas.cnig.es/CentroDescargasRWS/rest/listaArchivosRutas',
  MAR_COLOR: "#B3E3F9",
  TOKEN: 'nio348rbjk289hfjnkandfui2jb19ijksdf93oopowiopnkjvcmxñlaopfnhurbxcjiwmdoopqjcudfnxmaiqjru48927yfnnjcxnjwuh',
  LOGIN_NAME: 'CNIG',
  LOGIN_PASSWORD: '87654321',
  MINSCALE: 0.0001,
  LAND_OR_PORT: {width:1644, height:1048}, // type:"Landscape/Portrait", expectedSize ERROR
  FO_OR_POST_SLEY_LAND: {width:1953, height:1210}, // type:"Foto/PosterSinLeyenda.Landscape",
  FO_OR_POST_SLEY_PORT: {width:1915, height:1321}, // type:"Foto/PosterSinLeyenda.Portrait",
  POST_CLEY_LAND: {width:1709, height:1221}, // type:"PosterConLeyenda.Landscape",
  POST_CLEY_PORT: {width:1685, height:1321}, // type:"PosterConLeyenda.Portrait",
  TITLE_THEME_COLOR: '#364B5F',
  BUTTON_THEME_COLOR: '#DB8239',
};
